import { render, staticRenderFns } from "./OffersSlider.vue?vue&type=template&id=7fdb1674&scoped=true"
import script from "./OffersSlider.vue?vue&type=script&lang=js"
export * from "./OffersSlider.vue?vue&type=script&lang=js"
import style0 from "./OffersSlider.vue?vue&type=style&index=0&id=7fdb1674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb1674",
  null
  
)

export default component.exports